import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, sizes) => (dispatch, getState) => {
  dispatch({
    type: "SECTIONS/UPDATE_SECTION_COLUMNS",
    payload: { id, sizes }
  });
  debouncedSaveTemplate(dispatch, getState);
};
